// withRouterParams.tsx
import { useParams } from 'react-router-dom';

export function withRouterParams(Component: any) {
    return function WrappedComponent(props: any) {
        const params = useParams();
        return <Component {...props} params={params} />;
    };
}
